
import { defineComponent, ref, Ref, toRefs, watch, SetupContext, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { RadioGroup, Radio, List, PullRefresh } from 'vant'
import { NetworkpointItem } from '@/types/fault'
import { getWarehousePointList } from '@/apis/device-replace'
import refreshPageSetup from '@/compositions/refreshPage'
import getCacheFaultBillInfo from '@/compositions/fault/device'
import appHost from '@/utils/app'
import { UserLocationInfoStorage } from '@/storage/common'
import { WarehousePoint, GetWarehousePointParams } from '@/types/device-replace'
import { AuthLocationInfoType } from '@/types/public'

export default defineComponent({
  name: 'Fault-Points',
  components: {
    VanRadio: Radio,
    VanRadioGroup: RadioGroup,
    VanList: List,
    VanPullRefresh: PullRefresh,
  },
  props: {
    keywords: {
      type: String,
      required: true,
    },
  },
  emits: ['switchPoint'],
  setup(props, context) {
    const { keywords } = toRefs(props)
    let items: Ref<WarehousePoint[]> = ref([])
    const { cacheNetworkpoint } = getCacheFaultBillInfo()
    const checkItem: Ref<string> = ref(cacheNetworkpoint.value?.guid || '')
    let {
      error,
      loading,
      finished,
      refreshing,
      _query,
      _ts,
      generateLoad,
      generateRefresh,
      errorDealFunc,
    } = refreshPageSetup()
    const storageData = UserLocationInfoStorage.get<AuthLocationInfoType>()
    watch(checkItem, (): void => {
      let warehouseItem: WarehousePoint =
        items.value.find((it) => it.guid === checkItem.value) || null
      const obj: NetworkpointItem = {
        lat: Number(warehouseItem.latitude),
        lng: Number(warehouseItem.longitude),
        name: warehouseItem.company_name,
        address: warehouseItem.address,
        area: warehouseItem.area,
        contact_phone: warehouseItem.phone,
        distance: Number(warehouseItem.dis),
        guid: warehouseItem.guid,
        type: '',
      }
      context.emit('switchPoint', obj)
    })
    let timer: number
    const reGetItems = () => {
      if (timer) clearTimeout(timer)
      timer = setTimeout(() => {
        _ts = Date.now()
        items.value = []
        if (finished.value) {
          _query.page = 0
          finished.value = false
        } else {
          loading.value = true
          _query.page = 1
          getItems()
        }
      }, 800)
    }
    watch(keywords, (): void => {
      reGetItems()
    })
    const getItems = async (): Promise<void> => {
      const ts: number = _ts
      const { lng = 0, lat = 0 } = storageData
      const obj: GetWarehousePointParams = Object.assign({}, _query, {
        keyword: keywords.value as string,
        longitude: Number(lng),
        latitude: Number(lat),
      })
      try {
        const result: WarehousePoint[] = await getWarehousePointList(obj)
        if (ts !== _ts) return
        if (refreshing.value) {
          items.value = []
          refreshing.value = false
        }
        const list = result || []

        items.value = list
        loading.value = false
        finished.value = list.length < _query.per_page
      } catch (err: unknown) {
        if (ts !== _ts) return
        errorDealFunc(err as { message: string })
      }
    }
    const onLoad = generateLoad(getItems)
    const onRefresh = generateRefresh(getItems)
    onUnmounted(() => {
      if (timer) clearTimeout(timer)
    })
    const $router = useRouter()
    const toNetworkDetail = (item: WarehousePoint): void => {
      $router.push({ name: 'device-replace-v3-network-detail', params: { ...item } })
    }
    return {
      error,
      loading,
      finished,
      refreshing,
      _query,
      _ts,
      items,
      onLoad,
      onRefresh,
      checkItem,
      getItems,
      toNetworkDetail,
    }
  },
  methods: {
    onCallPoint(item: WarehousePoint): void {
      const phone = item?.phone || ''
      appHost.postCallPhone(phone.trim(), item.company_name)
    },
  },
})
